/**
 * @namespace SimpleSlider
 * @aka SWRNEU.SimpleSlider
 */
SWRNEU.SimpleSlider = function ($) {

  function SimpleSlider (options = {}) {
    if (!options.sliderList) {
      throw new Error('SimpleSlider: option "sliderList" is required.');
    }

    if (!options.ariaLabel) {
      throw new Error('SimpleSlider: option "ariaLabel" is required.');
    }

    this.element = options.sliderList[0];
    this.$element = options.sliderList;
    this.ariaLabel = options.ariaLabel;
    this.wrapperClass = options.wrapperClass || 'simple-slider-wrapper';
    this.buttonLabelPrev = options.buttonLabelPrev || `${this.ariaLabel} zurück blättern`;
    this.buttonLabelNext = options.buttonLabelNext || `${this.ariaLabel} weiter blättern`;
    this.buttonClassPrev = options.buttonClassPrev || 'simple-slider-prev';
    this.buttonClassNext = options.buttonClassNext || 'simple-slider-next';
    this.speed = options.speed || 1;

    this.init();
  }

  SimpleSlider.prototype.init = function () {
    const self = this;

    // Wrapper hinzufügen, wenn noch nicht vorhanden
    if (!self.$element.parent().hasClass(self.wrapperClass)) {
      self.$element.wrap(`<div class="simple-slider-wrapper"><nav class="${self.wrapperClass} simple-slider" aria-label="${self.ariaLabel}"></nav></div>`);
    }

    self.$wrapper = self.$element.parent();

    if (!self.$wrapper.prev().hasClass(self.buttonClassPrev)) {
      self.$buttonPrev = $(`
        <button type="button" class="btn btn-tertiary btn-icon ${self.buttonClassPrev} previous" aria-label="${self.buttonLabelPrev}">
          ${SWRNEU.Util.svgIcon('prev')}
        </button>`
      );

      self.$wrapper.before(self.$buttonPrev);
    }

    if (!self.$wrapper.next().hasClass(self.buttonClassNext)) {
      self.$buttonNext = $(`
        <button type="button" class="btn btn-tertiary btn-icon ${self.buttonClassNext} next" aria-label="${self.buttonLabelNext}">
          ${SWRNEU.Util.svgIcon('prev')}
        </button>`
      );

      self.$wrapper.after(self.$buttonNext);
    }

    // Initial prüfen
    self._updateFadeState();

    self._addEventListeners();
  };

  SimpleSlider.prototype._updateFadeState = function _updateFadeState () {
    const self = this;
    const scrollLeft = self.element.scrollLeft; // UL scrollt
    const maxScroll = self.element.scrollWidth - self.element.clientWidth;

    // Links-Fade
    if (scrollLeft > 5) {
      self.$wrapper.addClass('fade-left');
    } else {
      self.$wrapper.removeClass('fade-left');
    }

    // Rechts-Fade
    if (scrollLeft < maxScroll - 5) {
      self.$wrapper.addClass('fade-right');
    } else {
      self.$wrapper.removeClass('fade-right');
    }

    self.$buttonPrev.prop('disabled', scrollLeft <= 5);
    self.$buttonNext.prop('disabled', scrollLeft >= maxScroll - 5);
  };

  SimpleSlider.prototype._addEventListeners = function _addEventListeners () {
    const self = this;

    self.$buttonPrev.on('click', () => {
      self.$element.scrollLeft(self.element.scrollLeft - 150);
    });

    self.$buttonNext.on('click', () => {
      self.$element.scrollLeft(self.element.scrollLeft + 150);
    });

    // Scroll- und Resize-Events
    self.$element.on('scroll', () => self._updateFadeState());
    $(window).on('resize', () => self._updateFadeState());

    // --- Maus-Drag für Desktop ---
    let isDown = false;
    let dragDistance = 0;
    let startX;
    let scrollLeft;

    self.$element.on('mousedown', (e) => {
      isDown = true;
      dragDistance = 0;

      self.$element.addClass('dragging');

      startX = e.pageX - self.$element.offset().left;
      scrollLeft = self.$element.scrollLeft();
    });

    self.$element.on('mousemove', (e) => {
      if (!isDown) {
        return;
      }

      const x = e.pageX - self.$element.offset().left;
      const walk = (x - startX) * self.speed; // Geschwindigkeit anpassbar

      dragDistance = Math.max(dragDistance, Math.abs(x - startX));

      e.preventDefault();
      self.$element.scrollLeft(scrollLeft - walk);
    });

    $(document).on('mouseup', () => {
      isDown = false;

      self.$element.removeClass('dragging');
    });

    self.$element.on('click', 'a, button', (e) => {
      if (dragDistance > 2) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    });
  };

  return SimpleSlider;

}(window.jQuery);
